import { createContext, useContext, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { createPlanApi } from './api';

const Context = createContext(null);
// Caché de navegación: la API es la fuente de verdad; nunca guarda borradores.
export function PlanSessionProvider({ children, fixedBranchId = null }) {
  const [saved, setSaved] = useState(null);
  const token = useSelector(state => state.user.currentUser?.accessToken);
  const api = useMemo(() => createPlanApi(token), [token]);
  const [branchId, setBranchId] = useState(fixedBranchId);
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const sequence = useRef(0);
  const select = async (branch, id = null, { autoSelectSingle = true } = {}) => {
    if (fixedBranchId && branch !== fixedBranchId) return false;
    const ticket = ++sequence.current;
    setLoading(true); setError('');
    if (branch !== branchId) { setBranchId(branch); setPlans([]); setSaved(null); }
    try {
      const list = branch ? await api.list(branch) : [];
      const selectedId = id || (autoSelectSingle && list.length === 1 ? list[0].id : null);
      const plan = selectedId ? await api.get(selectedId) : null;
      if (ticket !== sequence.current) return false;
      setBranchId(branch); setPlans(list); setSaved(plan); return { plan };
    } catch (failure) { if (ticket === sequence.current) setError(failure.message); return false; }
    finally { if (ticket === sequence.current) setLoading(false); }
  };
  const save = async draft => {
    const ticket = ++sequence.current;
    const plan = await api.save(draft, saved, branchId);
    if (ticket === sequence.current) {
      setSaved(plan);
      setPlans(list => [...list.filter(p => p.id !== plan.id), { id: plan.id, name: plan.name, revision: plan.revision, updated_at: new Date().toISOString() }]);
    }
    return plan;
  };
  const remove = async () => {
    const ticket = ++sequence.current;
    await api.remove(saved);
    if (ticket === sequence.current) { setPlans(list => list.filter(p => p.id !== saved.id)); setSaved(null); }
  };
  return <Context.Provider value={{ api, saved, save, remove, branchId, fixedBranchId, plans, loading, error, select }}>{children}</Context.Provider>;
}
export const usePlanSession = () => useContext(Context);
